// import React from 'react'
import { PseudoBox, PseudoBoxProps as ChakraPseudoBoxProps } from '@chakra-ui/core'

export interface PseudoBoxProps extends ChakraPseudoBoxProps {}

export { PseudoBox }

// export const PseudoBox: React.FC<PseudoBoxProps> = (props: PseudoBoxProps) => {
//   return <ChakraPseudoBox {...props} />
// }

export default PseudoBox
